﻿$.fn.dxCtrlPiedTitleApp = function custom_dxCtrlPiedTitleApp(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpiedtitleapp dx-ctrl");
        this.createInstance(new cdxCtrlPiedTitleApp(this, option));
    }
    return this;
}

window.cdxCtrlPiedTitleApp = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();

        var appli = parametre.lst_appli_all.filter(function (o) { return o.code_appli == parametre.code_appli })[0]
        if (typeof option.codeAppli != 'undefined') {
            appli = parametre.lst_appli_all.filter(function (o) { return o.code_appli == option.codeAppli })[0]
        }

        $(document).attr("title", appli.nom)
        if (document.URLRacine.startsWith("https://portail")) {
            var link = $("link[rel*='icon']").first();
            link.attr("href", appli.img_logo_portail);
            $(document).attr("title", "Portail " + appli.nom);
        }
        if (window.location.origin != "null") history.pushState({ foo: 'bar' }, appli.nom, window.location.origin);

        var $Table = $("<table style='cursor:pointer;margin:10px;padding:5px 10px;border-radius:10px;display:inline-block;' class='state-hover'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;padding-right:5px;'><img src='" + appli.url_gif_logo + "' style='width:" + (option.widthImg ? option.widthImg : 50) + "px;'/></td>").appendTo($Tr)
        var $Td = $("<td style='width:1px;white-space:nowrap;font-size:" + (option.fontSize ? option.fontSize : "200%") + ";line-height:0.8;vertical-align:middle;text-align:left;color:" + theme.backgroundcolorAccent + ";'><div style='font-family:bangers;'>" + appli.nom + "</div><div style='font-size:" + (option.ssFontSize ? option.ssFontSize : "80%") + ";font-style:italic;'>" + appli.phrase_accroche + "</div></td>").appendTo($Tr)
        $Table.on("click", function (e) {
            e.stopPropagation()
            var url = parametre.urldispatch + "/pageSite.aspx?nb=" + option.bddCtrl.nom_base + "&iddest=&idcom=&typ=" + (option.type ? option.type : 7) + "&d=" + (new Date()).toFrenchDateTime()
            window.open(url, "_self")
            //window.open(((typeof option.urlVitrine == 'undefined') ? appli.urlvitrine : option.urlVitrine), "_blank")
        })

    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}